export const openExternalUrl = (url: string, shouldOpenInNewTab = true): Window | null => {
  if (!shouldOpenInNewTab) {
    window.location.assign(url);

    return null;
  }

  const wnd = window.open(url, '_blank', 'noopener,noreferrer');

  if (wnd) {
    wnd.opener = null;
  }

  return wnd;
};
